import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgApexchartsModule } from 'ng-apexcharts';
import { CounterCardComponent } from 'app/modules/global-components/counter-card/counter-card.component';
import { TablaRegistrosComponent } from '../../global-components/tabla-registros/tabla-registros.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import {
    ApexChart,
    ApexDataLabels,
    ApexFill,
    ApexLegend,
    ApexNonAxisChartSeries,
    ApexResponsive,
    ApexStroke,
    ApexTheme,
    ApexTooltip,
} from 'ng-apexcharts';
import { RegistrosInterface } from 'app/modules/global-components/tabla-registros/registros-interface';
import { RegistrosService } from '../registros/registros.service';
import { ListadoCarrerasDTO } from 'app/modules/models/carreras.model';
import { HomeService } from './home.service';
import { MetricasInterface } from 'app/modules/models/metricas.model';
import { DialogConfirmComponent } from 'app/modules/global-components/dialog-confirm.component.ts/dialog-confirm.component';
import { ApiService } from 'app/core/services/api.service';
import { ResponseInterface } from 'app/modules/models/response.model';
import { environment } from 'enviroments/environment';
import { Tipologia } from 'app/modules/models/tipologia.model';
import { MatTabsModule } from '@angular/material/tabs';



export type DonutChartOptions = {
    series: ApexNonAxisChartSeries;
    chart: ApexChart;
    labels: string[];
    legend: ApexLegend;
    responsive: ApexResponsive[];
    stroke: ApexStroke;
    dataLabels: ApexDataLabels;
    fill: ApexFill;
    colors: string[];
    theme?: ApexTheme;
    tooltip?: ApexTooltip;
    plotOptions?: any;
};

@Component({
    selector: 'app-home',
    templateUrl: 'home.component.html',
    standalone: true,
    imports: [
        CommonModule,
        NgApexchartsModule,
        CounterCardComponent,
        TablaRegistrosComponent,
        MatDialogModule,
        MatTabsModule
    ],
})

export class HomeComponent implements OnInit {
    datosEstadisticos: MetricasInterface | null = null;

    professionChartOptions: Partial<DonutChartOptions> = {};
    registros: RegistrosInterface[] = [];
    ciclos: Tipologia[] = [];
    tabIndex = 0;
    cicloSeleccionado: number = 0;
    cicloBasico: number | null = null;
    cicloDiversificado: number = environment.TIPOLOGIA_ID_CICLO_DIVERSIFICADO;
    cargandoRegistros = false;
    private readonly pageSize = 20;

    constructor(
        private _registrosService: RegistrosService,
        private _homeService: HomeService,
        private _dialog: MatDialog,
        private _apiService: ApiService
    ) {
        this.getCiclos();
    }

    ngOnInit() {
        // La configuración del gráfico se construye cuando llegan los datos
        this.getDatosEstadisticos();
    }

    private cargarRegistrosRecientes(): void {
        this.cargandoRegistros = true;
        const params: Record<string, number> = { inicio: 0, max: this.pageSize };
        const ciclo = Number(this.cicloSeleccionado || 0);
        if (!Number.isNaN(ciclo) && ciclo !== 0) {
            params.ciclo = ciclo;
        }
        this._registrosService.getListadoCarreras(params)
            .then((data: ListadoCarrerasDTO) => {
                this.registros = [...data.data as unknown as RegistrosInterface[]];
            })
            .catch((error) => {
                console.error('Error al cargar registros recientes', error);
            })
            .finally(() => {
                this.cargandoRegistros = false;
            });
    }

    onTabChange(index: number): void {
        this.tabIndex = index;
        const ciclo = index === 1 ? this.cicloDiversificado : (this.cicloBasico ?? 0);
        if (this.cicloSeleccionado === ciclo) {
            return;
        }
        this.cicloSeleccionado = ciclo;
        this.cargarRegistrosRecientes();
    }

    getDatosEstadisticos(){
        this._homeService.getEstadisticas()
        .then((response:MetricasInterface)=>{
            this.datosEstadisticos = response;

            if (!this.datosEstadisticos || !this.datosEstadisticos.graficaPastel) {
                return;
            }

            this.professionChartOptions = {
                series: this.datosEstadisticos.graficaPastel.map(item => item.total),
                labels: this.datosEstadisticos.graficaPastel.map(item => item.profesional),
                chart: {
                    type: 'donut',
                    height: 320,
                    toolbar: { show: false },
                    sparkline: { enabled: false },
                },
                plotOptions: {
                    pie: {
                        donut: {
                            size: '65%',
                            labels: {
                                show: true,
                                total: {
                                    show: true,
                                    label: 'Total',
                                    formatter: (w: any) => {
                                        const sum = w?.globals?.seriesTotals?.reduce((a: number, b: number) => a + b, 0) || 0;
                                        return `${sum}`;
                                    },
                                },
                            },
                        },
                    },
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'center',
                    fontSize: '14px',
                },
                dataLabels: { enabled: false },
                stroke: { width: 6 },
                fill: { opacity: 1 },
                colors: ['#2a7c9e', '#54c5cd', '#f97316'],
                responsive: [
                    {
                        breakpoint: 1024,
                        options: {
                            chart: { height: 280 },
                            legend: { fontSize: '13px' },
                        },
                    },
                ],
                tooltip: {
                    y: {
                        formatter: (val: number) => `${val}`,
                    },
                },
            };
        });
    }

    private getCiclos(): void {
        this._registrosService.getTipologias(environment.TIPOLOGIA_ID_CICLO)
            .then((response: Tipologia) => {
                this.ciclos = response.tipologias;
                const cicloBasico = this.ciclos.find((c) => c.tipologiaId !== this.cicloDiversificado);
                this.cicloBasico = cicloBasico?.tipologiaId ?? null;
                if (this.cicloSeleccionado === 0 && this.cicloBasico) {
                    this.cicloSeleccionado = this.cicloBasico;
                }
                if (this.cicloSeleccionado === this.cicloDiversificado) {
                    this.tabIndex = 1;
                } else {
                    this.tabIndex = 0;
                }
            })
            .catch((error) => {
                console.error('Error al obtener ciclos', error);
            })
            .finally(() => {
                this.cargarRegistrosRecientes();
            });
    }

    eliminarRegistro(registro: RegistrosInterface): void {
        const dialogRef = this._dialog.open(DialogConfirmComponent, {
            panelClass: ['md:w-4/12', 'w-full'],
            data: {
                message: `Está a punto de eliminar el registro ${registro.carrera}. ¿Desea continuar?`,
                inputPlaceholder: 'Motivo de eliminación'
            },
            disableClose: true
        });

        dialogRef.afterClosed().toPromise()
            .then(async (result: { confirmed: boolean; inputValue: string }) => {
                if (result?.confirmed) {
                    try {
                        const response = await this._registrosService.eliminarRegistro(registro.carreraUuid, result.inputValue) as ResponseInterface;
                        this._apiService.showSuccessMessage(response.message ?? 'Registro se eliminó correctamente');
                        this.cargarRegistrosRecientes();
                    } catch (error) {
                        console.error('Error al eliminar el registro', error);
                        this._apiService.showErrorMessage('No se pudo eliminar el registro');
                    }
                }
            })
            .catch(error => {
                console.error('Error al cerrar el diálogo de eliminación', error);
            });
    }

    publicarRegistro(registro: RegistrosInterface): void {
        const message = `Está a punto de publicar el registro ${registro.carrera}. ¿Desea continuar?`;

        this._apiService.open_confirm_dialog(message).subscribe((confirmado) => {
            if (!confirmado) { return; }

            this._registrosService.publicarRegistro(registro.carreraUuid)
                .then((response: ResponseInterface) => {
                    this._apiService.showSuccessMessage(response.message ?? 'Registro publicado correctamente');
                    this.cargarRegistrosRecientes();
                })
                .catch(error => {
                    console.error('Error al publicar el registro', error);
                    this._apiService.showErrorMessage('No se pudo publicar el registro');
                });
        });
    }
}
